
import { BUSINESS_UNIT_ADDRESS_METADATA } from './business-unit-address.metadata';
import { BusinessUnitAddressBase } from './business-unit-address.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface BusinessUnitAddress extends BusinessUnitAddressBase {
}

export interface BusinessUnitAddressTransient { }

export class BusinessUnitAddress extends CrudEntity<BusinessUnitAddress, number, BusinessUnitAddressTransient> implements BusinessUnitAddressTransient {
  constructor(source?: Partial<BusinessUnitAddress>, options?: CrudEntityConstructionOptions<BusinessUnitAddress, number, BusinessUnitAddressTransient>) {
    super(BUSINESS_UNIT_ADDRESS_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





